import { PrintReceipts, PrintStyles, ReceiptPreview } from '@/components/PrintReceipts'
import { usePrintDispatch } from '@/hooks/usePrintDispatch'
import { Order, Printer, SharedProps } from '@/types'
import { Head, router } from '@inertiajs/react'
import { Button, Container, Group, Paper, Stack, Title } from '@mantine/core'
import { IconArrowLeft, IconPrinter } from '@tabler/icons-react'
import axios from 'axios'

interface OrderPrintProps extends SharedProps {
  order: Order
  printers: Printer[]
  receipts_html: string[]
}

function PrinterButton({
  printer,
  loading,
  onPrint,
}: {
  printer: Printer
  loading: boolean
  onPrint: (printerId: number) => void
}) {
  const handleClick = () => onPrint(printer.id)

  return (
    <Button leftSection={<IconPrinter size={20} />} onClick={handleClick} size="lg" fullWidth loading={loading}>
      {printer.name}
    </Button>
  )
}

export default function OrderPrintsIndex({ order, current_organization, printers, receipts_html }: OrderPrintProps) {
  const organizationSlug = current_organization?.slug || ''

  const sendPrintJobs = (printerId: number | null) =>
    axios.post(`/organizations/${organizationSlug}/print_jobs`, {
      order_id: order.id,
      printer_id: printerId,
      replace_pending_jobs: true,
    })

  const { cloudprntEnabled, printingPrinterId, printBrowser, printToPrinter } = usePrintDispatch({ send: sendPrintJobs })

  const handleBack = () => router.visit(`/organizations/${organizationSlug}/orders/${order.id}`)
  const handleDefaultPrint = () => (cloudprntEnabled ? printToPrinter(null) : printBrowser())
  const showPrinterButtons = cloudprntEnabled && printers.length > 0

  return (
    <>
      <Head>
        <title>{`Impression - Commande #${order.id}`}</title>
      </Head>
      <PrintStyles />

      <Container className="no-print">
        <Stack gap="lg">
          <Group justify="space-between">
            <Button variant="subtle" leftSection={<IconArrowLeft size={16} />} onClick={handleBack}>
              Retour
            </Button>
            <Title order={3}>Impression Commande #{order.id}</Title>
          </Group>

          <Paper withBorder p="xl" radius="md" shadow="sm">
            <Stack gap="sm">
              {showPrinterButtons ? (
                printers.map((printer) => (
                  <PrinterButton
                    key={printer.id}
                    printer={printer}
                    loading={printingPrinterId === printer.id}
                    onPrint={printToPrinter}
                  />
                ))
              ) : (
                <Button
                  leftSection={<IconPrinter size={20} />}
                  onClick={handleDefaultPrint}
                  size="lg"
                  fullWidth
                  loading={printingPrinterId === null}
                >
                  Imprimer
                </Button>
              )}
            </Stack>
          </Paper>

          <ReceiptPreview receipts_html={receipts_html} />
        </Stack>
      </Container>

      <PrintReceipts receipts_html={receipts_html} />
    </>
  )
}
